import { TruckFastIcon } from './TruckFastIcon';

/**
 * author: Austin Andrews
 * id 401AC514-6441-4DDC-80DC-48CF851C5B5E
 * name truck-fast
 * version: 1.9.32
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/truck-fast.svg
 * tags
 * - Transportation + Road 
 */
export const CourierFastIcon = TruckFastIcon;
export default CourierFastIcon